import React from 'react';
import trans from 'translate';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CircularProgress from '../CircularProgress/CircularProgress';
import WalletLauncher from '../../hoc/WalletLauncher/WalletLauncher';
import './Button.scss';
import WalletValidator from '../../hoc/WalletValidator/WalletValidator';

const Button = ({
  onClick,
  style,
  loading,
  bgColor,
  loadingText,
  className,
  text,
  type = 'button',
  disabled,
  requireWallet,
  requireChampWallet,
  ...rest
}) => {
  const classNames = clsx(className, { disabled });
  return (
    <WalletLauncher disabled={!requireWallet} action={text}>
      <WalletValidator disabled={!requireChampWallet} style={{ ...style }}>
        <button
          // eslint-disable-next-line react/button-has-type
          type={type}
          onClick={onClick}
          className={`button ${classNames} d-flex align-center gap-2`}
          style={{ ...style, backgroundColor: bgColor }}
          disabled={disabled || loading}
          {...rest}
        >
          {trans(loading ? loadingText : text)}
          {loading && <CircularProgress />}
        </button>
      </WalletValidator>
    </WalletLauncher>
  );
};

Button.defaultProps = {
  onClick: () => {},
  style: undefined,
  className: '',
  type: 'button',
  disabled: false,
  loading: false,
  loadingText: '',
  bgColor: '',
  requireWallet: false,
  requireChampWallet: false,
};

Button.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  bgColor: PropTypes.string,
  requireWallet: PropTypes.bool,
  requireChampWallet: PropTypes.bool,
};

export default Button;
